import styled from 'styled-components/macro';

export const SvgComponent = styled.svg`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) translateZ(0) scale(1.0, 1.0);
`;
